import React from 'react';

export interface Props {
  heading: string;
  content: React.ReactNode;
}
const HeadingWithTextContent = (props: Props) => {
  const { heading, content } = props;
  return (
    <div id='generic-headingwithtextcontent-wrapper' className="flex flex-col w-full h-full gap-[6px]">
      <label id={`generic-headingwithtextcontent-${heading}`} className="text-base font-normal leading-normal text-[#212529] text-left">
        {heading}
      </label>
      {content}
    </div>
  );
};

export default HeadingWithTextContent;
